import { FieldProse, NumberedSection, RegaraNoteList } from './DossierPrimitives';

/**
 * EU IVDR (Reg 2017/746) Performance Evaluation (Article 56 / Annex XIII) renderer.
 * Parity: backend/services/dossier/eu_ivdr_performance_eval_renderer
 * (`performance_eval_sections_html`). The IVD analog of MDR clinical requirements,
 * but its own shape: `sections` of {title, applicability, basis, notes} + notes.
 */

interface PerfEvalSection {
  title?: string;
  applicability?: string | null;
  basis?: string | null;
  notes?: string | null;
}

export interface PerfEvalResult {
  device_class?: string;
  sections?: PerfEvalSection[];
  notes?: string[];
}

export function IvdrPerformanceEvalRenderer({ result }: { result: PerfEvalResult }) {
  const sections = Array.isArray(result.sections) ? result.sections : [];
  const notes = Array.isArray(result.notes) ? result.notes : [];

  return (
    <div className="space-y-4">
      {sections.map((s, i) => (
        <NumberedSection
          key={i}
          prefix="Section"
          num={i + 1}
          title={s.title || `Performance Evaluation Section ${i + 1}`}
        >
          <FieldProse label="Applicability:" body={s.applicability ?? null} fallbackHint="Applicability" />
          <FieldProse label="Basis:" body={s.basis ?? null} fallbackHint="Basis" />
          {s.notes != null && <FieldProse label="Notes:" body={s.notes} fallbackHint="Notes" />}
        </NumberedSection>
      ))}

      <RegaraNoteList notes={notes} />
    </div>
  );
}
